import type { SceneNode } from "../scene/model";
export function groupMembers(nodes: readonly SceneNode[], id: string) {
  return nodes.filter((n) => n.layer.groupId === id);
}
export function assignGroup(
  nodes: readonly SceneNode[],
  ids: readonly string[],
  id: string,
  name = "Группа",
) {
  const selected = new Set(ids);
  return nodes.map((n) =>
    selected.has(n.id)
      ? {
          ...n,
          layer: {
            ...n.layer,
            groupId: id,
            groupName: name,
            groupCollapsed: false,
          },
        }
      : n,
  );
}
export function ungroup(nodes: readonly SceneNode[], id: string) {
  return nodes.map((n) => {
    if (n.layer.groupId !== id) return n;
    const layer = { ...n.layer };
    delete layer.groupId;
    delete layer.groupName;
    delete layer.groupCollapsed;
    delete layer.block;
    delete layer.blockRole;
    return { ...n, layer };
  });
}
export function clippingBase(nodes: readonly SceneNode[], node: SceneNode) {
  for (let i = nodes.indexOf(node) - 1; i >= 0; i--)
    if (!nodes[i]!.layer.clipToBelow) return nodes[i];
  return undefined;
}
export function remapCopiedGroups(
  copies: SceneNode[],
  original: readonly SceneNode[],
  sourceIds: readonly string[],
  newId: () => string,
  otherDocument = false,
) {
  const groups = new Map<string, string>();
  for (const n of copies) {
    const id = n.layer.groupId;
    if (typeof id !== "string" || !id) continue;
    if (
      otherDocument ||
      groupMembers(original, id).every((m) => sourceIds.includes(m.id))
    ) {
      if (!groups.has(id)) groups.set(id, newId());
      n.layer.groupId = groups.get(id)!;
    }
  }
  return copies;
}
